"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["data"];
const _hoisted_2 = { class: "preferences_panel_item" };
const _hoisted_3 = { class: "form-switch" };
const _hoisted_4 = { class: "preferences_panel_item" };
const _hoisted_5 = { class: "form-switch" };
const _hoisted_6 = { class: "preferences_panel_item" };
const _hoisted_7 = { class: "form-switch" };
const _hoisted_8 = { class: "preferences_panel_item" };
const _hoisted_9 = { class: "form-switch" };
const _hoisted_10 = { class: "preferences_panel_item" };
const _hoisted_11 = { class: "form-switch" };
const _hoisted_12 = { class: "preferences_panel_item" };
const _hoisted_13 = { class: "form-switch" };
const _hoisted_14 = { class: "preferences_panel_item" };
const _hoisted_15 = { class: "form-switch" };
const _hoisted_16 = { class: "preferences_panel_item" };
const _hoisted_17 = { class: "form-switch" };
const _hoisted_18 = { class: "preferences_panel_item" };
const _hoisted_19 = { class: "form-switch" };
const _hoisted_20 = { class: "preferences_panel_item" };
const _hoisted_21 = { class: "form-switch" };
const _hoisted_22 = ["data-tooltip"];
const _hoisted_23 = { class: "preferences_panel_item" };
const _hoisted_24 = { class: "form-switch" };
const _hoisted_25 = ["data-tooltip"];
const _hoisted_26 = { class: "preferences_panel_item" };
const _hoisted_27 = { class: "form-switch" };
const _hoisted_28 = ["data-tooltip"];
const _hoisted_29 = { class: "preferences_panel_item" };
const _hoisted_30 = { class: "form-switch" };
const _hoisted_31 = ["data-tooltip"];
const _hoisted_32 = { class: "preferences_panel_item" };
const _hoisted_33 = { class: "form-switch" };
const _hoisted_34 = ["data-tooltip"];
const _hoisted_35 = { class: "preferences_panel_actions" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_bug_report_dialog = (0, vue_1.resolveComponent)("bug-report-dialog");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: "preferences_panel",
        data: _ctx.syncPreferences()
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("label", _hoisted_3, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[0] || (_cache[0] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.prefs.hide_awards_and_milestones) = $event)),
                    "data-test": "hide_awards_and_milestones"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.hide_awards_and_milestones]
                ]),
                _cache[31] || (_cache[31] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[32] || (_cache[32] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[30] || (_cache[30] = [
                        (0, vue_1.createTextVNode)("Hide awards and milestones", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_4, [
            (0, vue_1.createElementVNode)("label", _hoisted_5, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[2] || (_cache[2] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.prefs.small_cards) = $event)),
                    "data-test": "small_cards"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.small_cards]
                ]),
                _cache[34] || (_cache[34] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[35] || (_cache[35] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[33] || (_cache[33] = [
                        (0, vue_1.createTextVNode)("Smaller cards", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_6, [
            (0, vue_1.createElementVNode)("label", _hoisted_7, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[4] || (_cache[4] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.prefs.magnify_cards) = $event)),
                    "data-test": "magnify_cards"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.magnify_cards]
                ]),
                _cache[37] || (_cache[37] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[38] || (_cache[38] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[36] || (_cache[36] = [
                        (0, vue_1.createTextVNode)("Magnify cards on hover", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_8, [
            (0, vue_1.createElementVNode)("label", _hoisted_9, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[6] || (_cache[6] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.prefs.hide_discount_on_cards) = $event)),
                    "data-test": "hide_discount_on_cards"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.hide_discount_on_cards]
                ]),
                _cache[40] || (_cache[40] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[41] || (_cache[41] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[39] || (_cache[39] = [
                        (0, vue_1.createTextVNode)("Hide discount on cards", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_10, [
            (0, vue_1.createElementVNode)("label", _hoisted_11, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[8] || (_cache[8] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.prefs.remove_background) = $event)),
                    "data-test": "remove_background"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.remove_background]
                ]),
                _cache[43] || (_cache[43] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[44] || (_cache[44] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[42] || (_cache[42] = [
                        (0, vue_1.createTextVNode)("Remove background image", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_12, [
            (0, vue_1.createElementVNode)("label", _hoisted_13, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[10] || (_cache[10] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.prefs.show_alerts) = $event)),
                    "data-test": "show_alerts"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.show_alerts]
                ]),
                _cache[46] || (_cache[46] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[47] || (_cache[47] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[45] || (_cache[45] = [
                        (0, vue_1.createTextVNode)("Show in-game alerts", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_14, [
            (0, vue_1.createElementVNode)("label", _hoisted_15, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[12] || (_cache[12] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.prefs.enable_sounds) = $event)),
                    "data-test": "enable_sounds"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.enable_sounds]
                ]),
                _cache[49] || (_cache[49] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[50] || (_cache[50] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[48] || (_cache[48] = [
                        (0, vue_1.createTextVNode)("Enable sounds", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_16, [
            (0, vue_1.createElementVNode)("label", _hoisted_17, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[14] || (_cache[14] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.prefs.hide_animated_sidebar) = $event)),
                    "data-test": "hide_animated_sidebar"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.hide_animated_sidebar]
                ]),
                _cache[52] || (_cache[52] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[53] || (_cache[53] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[51] || (_cache[51] = [
                        (0, vue_1.createTextVNode)("Hide sidebar notification", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_18, [
            (0, vue_1.createElementVNode)("label", _hoisted_19, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[16] || (_cache[16] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.prefs.hide_tile_confirmation) = $event)),
                    "data-test": "hide_tile_confirmation"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.hide_tile_confirmation]
                ]),
                _cache[55] || (_cache[55] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                _cache[56] || (_cache[56] = (0, vue_1.createTextVNode)()),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[54] || (_cache[54] = [
                        (0, vue_1.createTextVNode)("Hide tile confirmation", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_20, [
            (0, vue_1.createElementVNode)("label", _hoisted_21, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[18] || (_cache[18] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.prefs.learner_mode) = $event)),
                    "data-test": "learner_mode"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.learner_mode]
                ]),
                _cache[58] || (_cache[58] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[57] || (_cache[57] = [
                        (0, vue_1.createTextVNode)("Learner Mode (req. refresh)", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("span", {
                    class: "tooltip tooltip-left",
                    "data-tooltip": _ctx.$t('Show information that can be helpful\n to players who are still learning the games')
                }, "ⓘ", 8, _hoisted_22)
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_23, [
            (0, vue_1.createElementVNode)("label", _hoisted_24, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[20] || (_cache[20] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.prefs.symbol_overlay) = $event)),
                    "data-test": "symbol_overlay"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.symbol_overlay]
                ]),
                _cache[60] || (_cache[60] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[59] || (_cache[59] = [
                        (0, vue_1.createTextVNode)("Symbol Overlay", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("span", {
                    class: "tooltip tooltip-left",
                    "data-tooltip": _ctx.$t('Add symbols on top of player colors.')
                }, "ⓘ", 8, _hoisted_25)
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_26, [
            (0, vue_1.createElementVNode)("label", _hoisted_27, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[22] || (_cache[22] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.prefs.animated_title) = $event)),
                    "data-test": "animated_title"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.animated_title]
                ]),
                _cache[62] || (_cache[62] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[61] || (_cache[61] = [
                        (0, vue_1.createTextVNode)("Animated Title", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("span", {
                    class: "tooltip tooltip-left",
                    "data-tooltip": _ctx.$t('Show spinning circle in window title on your turn.')
                }, "ⓘ", 8, _hoisted_28)
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_29, [
            (0, vue_1.createElementVNode)("label", _hoisted_30, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[24] || (_cache[24] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.prefs.experimental_ui) = $event)),
                    "data-test": "experimental_ui"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.experimental_ui]
                ]),
                _cache[64] || (_cache[64] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[63] || (_cache[63] = [
                        (0, vue_1.createTextVNode)("Experimental UI", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("span", {
                    class: "tooltip tooltip-left",
                    "data-tooltip": _ctx.$t('Test out any possible new experimental UI features for feedback.')
                }, "ⓘ", 8, _hoisted_31)
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_32, [
            (0, vue_1.createElementVNode)("label", _hoisted_33, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    onChange: _cache[26] || (_cache[26] =
                        (...args) => (_ctx.updatePreferences && _ctx.updatePreferences(...args))),
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.prefs.debug_view) = $event)),
                    "data-test": "debug_view"
                }, null, 544), [
                    [vue_1.vModelCheckbox, _ctx.prefs.debug_view]
                ]),
                _cache[66] || (_cache[66] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[65] || (_cache[65] = [
                        (0, vue_1.createTextVNode)("Debug View", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("span", {
                    class: "tooltip tooltip-left",
                    "data-tooltip": _ctx.$t('Add information useful for development and debugging.')
                }, "ⓘ", 8, _hoisted_34)
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_35, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                class: "btn btn-lg btn-primary",
                onClick: _cache[28] || (_cache[28] =
                    (...args) => (_ctx.okClicked && _ctx.okClicked(...args)))
            }, [...(_cache[67] || (_cache[67] = [
                    (0, vue_1.createTextVNode)("Ok", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                class: "btn btn-lg btn-primary",
                onClick: _cache[29] || (_cache[29] =
                    (...args) => (_ctx.showBugDialog && _ctx.showBugDialog(...args)))
            }, [...(_cache[68] || (_cache[68] = [
                    (0, vue_1.createTextVNode)("Report a bug", -1)
                ]))])), [
                [_directive_i18n]
            ])
        ]),
        (0, vue_1.createVNode)(_component_bug_report_dialog, { ref: "bugDialog" }, null, 512)
    ], 8, _hoisted_1));
}
